import axios from "axios";
import { handleSwalTokenExpired } from "../utils";
import config from "../config/app.config";
import { getToken } from "../config/authsave";

// สร้าง instance ของ axios
const apiAuthorization = axios.create({
  baseURL: config.apiURL, // เปลี่ยนเป็น URL ของคุณ
  headers: {
    "Content-Type": "application/json",
  },
});

// --- Request Interceptor ---
apiAuthorization.interceptors.request.use(
  (resData) => {
    // ดึง token จาก localStorage (ซึ่ง AuthProvider ของเราบันทึกไว้)
    const token = getToken();

    if (token) {
      // ใส่ Token ลงใน Authorization Header
      resData.headers.Authorization = `Bearer ${token}`;
    }
    return resData;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// --- Response Interceptor (เผื่อ Token หมดอายุ) ---
apiAuthorization.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // ถ้า Token หมดอายุ หรือไม่ถูกต้อง
      handleSwalTokenExpired(
        "Token expired.",
        "โทเค็นหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง",
      );
    }
    return Promise.reject(error);
  },
);

export default apiAuthorization;
